import * as React from 'react';
import { IAgreement } from './Entities';
import { Translate } from '../../shared/LanguageService';
import { Table } from 'react-bootstrap';
import AgreementsListRow from './AgreementsListRow';

interface IAgreementsListProps {
    agreements: IAgreement[];
    edit: (id: number) => void;
    delete: (id: number) => any;
    logs: (id: number) => void;
    openDeleteModal: (agreement: IAgreement) => void;
}

const AgreementsList = (props: IAgreementsListProps) => {
    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>{Translate('agreements/list/table-header/name')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.agreements &&
                    props.agreements.map((u: IAgreement) => {
                        return (
                            <AgreementsListRow
                                agreement={u}
                                key={u.id}
                                edit={props.edit}
                                delete={props.delete}
                                logs={props.logs}
                                openDeleteModal={props.openDeleteModal}
                            />
                        );
                    })}
            </tbody>
        </Table>
    );
};

export default AgreementsList;
